import {Link} from "react-router-dom";
import noImage from '../../assets/no_image.jpg'


export default function CardViewTv(props) {
    const {movie, size} = props
    return (
        <div className="card-view my-2">
            <div className="card-header">
                <Link to={'/tv/' + movie.id}>
                    {
                        movie.poster_path !== null && movie.poster_path.length > 0  ?
                            <img className="img-fluid w-100" src={size + movie.poster_path}
                                 title={movie.title} alt={movie.title}/>
                            :
                            <img className="img-fluid w-100" src={noImage} title={movie.title}
                                 alt={movie.title}/>
                    }
                </Link>
            </div>
            <div className="card-movie-content">
                <div className="card-movie-content-head">
                    <Link to={'/tv/' + movie.id} className="d-block text-center">{movie.original_name}</Link>
                    <div className="ratings"><span>{movie.vote_average}</span>/10</div>
                </div>
            </div>
        </div>
    )
}